// extracted by mini-css-extract-plugin
module.exports = {"mobileHeaderHeight":"65","desktopHeaderHeight":"85"};